import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
// import classNames from 'classnames';
// import config from '../../config';
import {
  // IconSocialMediaFacebook,
  // IconSocialMediaInstagram,
  // IconSocialMediaTwitter,
  // Logo,
  ExternalLink,
  NamedLink,
  // NewsletterForm,
  NewsletterPanel,
} from '..';

import insta from '../../assets/icons/socialmedia/instagram-iconTenerif.png';
import fb from '../../assets/icons/socialmedia/facebook-iconTenerif.png';
import linkedIn from '../../assets/icons/socialmedia/linkiedin-iconTenerif.png';

import css from './Footer.css';


import coronaEN from '../../assets/CoronaRules/CoronaEN.pdf';
import coronaDE from '../../assets/CoronaRules/CoronaDE.pdf';

import safetyInfoEN from '../../assets/safetyInfo/safetyInfoEN.pdf';
import safetyInfoDE from '../../assets/safetyInfo/safetyInfoDE.pdf';
import childProtectionPolicy from '../../assets/ChildProtection/ChildProtectionPolicy.pdf';
import KinderschutzPolicy from '../../assets/ChildProtection/KinderschutzPolicy.pdf';

import qualityCriteriaDE from '../../assets/qualityCriteria/qualityCriteriaDE.pdf';
import qualityCriteriaEN from '../../assets/qualityCriteria/qualityCriteriaEN.pdf';

import travelerGuidlines from '../../assets/travelGuidlines/TravelerGuidelines.pdf';
import reisendeGuidlines from '../../assets/travelGuidlines/GuidelineFuerReisende.pdf';

import file2022de from '../../assets/aboutPage/ImpactReports/ImpactReport22-de.pdf';
import file2022en from '../../assets/aboutPage/ImpactReports/ImpactReport22-en.pdf';

import article1 from '../../assets/partners/BMWK.png';
import article2 from '../../assets/partners/ClaimESF.png';
import article5 from '../../assets/partners/ESF.png';
import article6 from '../../assets/partners/EU.png';
import article7 from '../../assets/partners/Exist.png';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

// const renderSocialMediaLinks = intl => {
//   const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
//   const siteTwitterPage = twitterPageURL(siteTwitterHandle);

//   const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
//   const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
//   const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });

//   const fbLink = siteFacebookPage ? (
//     <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
//       <IconSocialMediaFacebook />
//     </ExternalLink>
//   ) : null;

//   const twitterLink = siteTwitterPage ? (
//     <ExternalLink
//       key="linkToTwitter"
//       href={siteTwitterPage}
//       className={css.icon}
//       title={goToTwitter}
//     >
//       <IconSocialMediaTwitter />
//     </ExternalLink>
//   ) : null;

//   const instragramLink = siteInstagramPage ? (
//     <ExternalLink
//       key="linkToInstagram"
//       href={siteInstagramPage}
//       className={css.icon}
//       title={goToInsta}
//     >
//       <IconSocialMediaInstagram />
//     </ExternalLink>
//   ) : null;
//   return [fbLink, twitterLink, instragramLink].filter(v => v != null);
// };

const Footer = () => {
  // const { rootClassName, className, intl } = props;
  // const socialMediaLinks = renderSocialMediaLinks(intl);
  // const classes = classNames(rootClassName || css.root, className);


  // device detection
  const isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;

  const socialmediaWeb =
    isMobile === false ? (
      <div className={css.socialWrapper}>
        <h1 className={css.socialHeader}>
          <FormattedMessage id="socialmedia.headline" />
        </h1>
        <p className={css.socialSub}>
          <FormattedMessage id="socialmedia.subheadline" />
        </p>
        {/* <div className={css.someLinks}>{socialMediaLinks}</div> */}

        <div className={css.socialButtons}>
          <ExternalLink href="https://www.instagram.com/socialbnb/" className={css.link}>
            <img src={insta} className={css.socialmedia} alt=""></img>
          </ExternalLink>
          <ExternalLink href="https://www.facebook.com/Socialbnb" className={css.link}>
            <img src={fb} className={css.socialmedia} alt=""></img>
          </ExternalLink>
          <ExternalLink href="https://www.linkedin.com/company/socialbnb/" className={css.link}>
            <img src={linkedIn} className={css.socialmedia} alt=""></img>
          </ExternalLink>
        </div>
      </div>
    ) : null;

  const socialmediaMobile =
    isMobile === true ? (
      <div className={css.socialWrapperMobile}>
        <h1 className={css.socialHeader}>
          <FormattedMessage id="socialmedia.headline" />
        </h1>
        <p className={css.socialSub}>
          <FormattedMessage id="socialmedia.subheadline" />
        </p>
        {/* <div className={css.someLinks}>{socialMediaLinks}</div> */}

        <div className={css.socialButtons}>
          <ExternalLink href="https://www.instagram.com/socialbnb/" className={css.link}>
            <img src={insta} className={css.socialmedia} alt=""></img>
          </ExternalLink>
          <ExternalLink href="https://www.facebook.com/Socialbnb" className={css.link}>
            <img src={fb} className={css.socialmedia} alt=""></img>
          </ExternalLink>
          <ExternalLink href="https://www.linkedin.com/company/socialbnb/" className={css.link}>
            <img src={linkedIn} className={css.socialmedia} alt=""></img>
          </ExternalLink>
        </div>
      </div>
    ) : null;
  const currentYear = new Date().getFullYear();

  var mediaQuery = null;
  if (typeof window !== 'undefined') {
    mediaQuery = window.matchMedia('(min-width: 768px)');
  }

  return (
    <div className={css.footer}>

      <div className={css.newscardWrapper}>
        <div className={css.verticleLine}>
          <span></span>
        </div>
        <span className={css.transparentBg}></span>


        <div className={css.newsletterWrapper}>
          <h1 className={css.newsletterHeader}>
            <FormattedMessage id="newsletter.headline" />
          </h1>
          <p className={css.newsletterSub}>
            <FormattedMessage id="newsletter.subheadline" />
          </p>
          <NewsletterPanel/>
        </div>

        {socialmediaWeb}

      </div>

      {socialmediaMobile}




      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          {/*<div className={css.someLiksMobile}>{socialMediaLinks}</div>*/}

          {/* The only reason of mediaQuery usage is because fundedBy section is positioning differently on mobile and desktop */}
          {mediaQuery ? (
            mediaQuery.matches ? (
              <div className={css.links}>
                {/* <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}>
                <Logo format="desktop" className={css.logo} />
              </NamedLink>
              <div className={css.organizationInfo}>
                <p className={css.organizationDescription}>
                  <FormattedMessage id="landing.headline1" />
                </p>
                <p className={css.organizationCopyright}>
                  <NamedLink name="LandingPage" className={css.copyrightLink}>
                    <FormattedMessage id="Footer.copyright" />
                  </NamedLink>
                </p>
              </div>
            </div> */}

                <div className={css.infoLinks}>
                  <ul className={css.list}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="Footer.intro" />
                      </h3>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink name="LandingPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.start" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink name="AboutPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.about" />
                      </NamedLink>
                    </li>
                  </ul>

                 {/*  <ul className={`${css.list} ${css.fundedByList}`}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="Footer.fundedBy" />
                      </h3>
                    </li>

                    <div className={css.fundedByWrapper}>
                      <div className={css.fundedBy}>
                        <ExternalLink
                          href="https://www.bmwi.de/Navigation/DE/Home/home.html"
                          target="_blank"
                          style={{ height: '100%' }}
                        >
                          <img src={article1} alt="article1"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink>
                          <img src={article2} alt="article2"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink
                          href="https://www.esf.de/portal/DE/Startseite/inhalt.html"
                          target="_blank"
                          style={{ height: '100%' }}
                        >
                          <img src={article5} alt="article5"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink>
                          <img src={article6} alt="article6"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink
                          href="https://www.exist.de/DE/Home/inhalt.html"
                          target="_blank"
                          style={{ height: '100%' }}
                        >
                          <img src={article7} alt="article7"></img>
                        </ExternalLink>
                      </div>
                    </div>
                  </ul> */}
                </div>
                <div className={css.searches}>
                  <ul className={css.list}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="TopbarDesktop.destinations" />
                      </h3>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=85.051129%2C179.00736739%2C-75.14077719%2C-160.60200761',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="worldwide" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=36.59497175%2C52.76846679%2C-36.15117826%2C-34.86957672',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="africa" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=64.09173416%2C169.49644716%2C-14.97311392%2C58.14770588',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="asia" />
                      </NamedLink>
                    </li>

                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=66.75842601%2C44.21184607%2C26.75060877%2C-31.82643116',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="europe" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search:
                            '?bounds=34.15056365%2C-25.99456573%2C-59.50348924%2C-150.22941462',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="southamerica" />
                      </NamedLink>
                    </li>
                  </ul>
                </div>


                <div className={css.searchesExtra}>
                  <ul className={css.list}>
                    <h3 className={css.legalLink}>
                      <FormattedMessage id="Footer.info" />
                    </h3>
                    <li className={css.listItem}>
                      <NamedLink name="FaqPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.FAQ" />
                      </NamedLink>
                    </li>

                    <li className={css.listItem}>
                      <NamedLink name="ContactPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.Contact" />
                      </NamedLink>
                    </li>

                    <li className={css.listItem}>
                      <ExternalLink href="https://blog.socialbnb.org/press" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.Press" />
                      </ExternalLink>
                    </li>
                    <li className={css.listItem}>
                      <ExternalLink href="https://blog.socialbnb.org/" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.Blog" />
                      </ExternalLink>
                    </li>

                  </ul>
                </div>

                <div className={css.infoLinks}>
                  <ul className={css.list}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="Downloads" />
                      </h3>
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={safetyInfoEN}>
                          <FormattedMessage id="Footer.SafetyInfo" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={safetyInfoDE}>
                          <FormattedMessage id="Footer.SicherheitInfo" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={coronaEN}>
                          <FormattedMessage id="Footer.corona" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={coronaDE}>
                          <FormattedMessage id="Footer.corona" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={childProtectionPolicy}>
                          <FormattedMessage id="Footer.childProtectionPolicy" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={KinderschutzPolicy}>
                          <FormattedMessage id="Footer.childProtectionPolicy" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={travelerGuidlines}>
                          <FormattedMessage id="Footer.guidline" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={reisendeGuidlines}>
                          <FormattedMessage id="Footer.guidline" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={qualityCriteriaEN}>
                          <FormattedMessage id="Footer.qualityCriteria" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={qualityCriteriaDE}>
                          <FormattedMessage id="Footer.qualityCriteria" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={file2022en}>
                          <FormattedMessage id="about.impactReportHeadline" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={file2022de}>
                          <FormattedMessage id="about.impactReportHeadline" />
                        </ExternalLink>
                      )}
                    </li>
                  </ul>
                </div>






                <div className={css.extraLinks}>
                  <div className={css.legalMatters}>
                    <ul className={css.tosAndPrivacy}>
                      <li>
                        <h3 className={css.legalLink}>
                          <FormattedMessage id="Footer.legal" />
                        </h3>
                      </li>
                      <li>
                        <NamedLink name="Imprint" className={css.legalLink}>
                          <FormattedMessage id="Footer.imprint" />
                        </NamedLink>
                      </li>
                      <li>
                        <NamedLink name="TermsOfServicePage" className={css.legalLink}>
                          <FormattedMessage id="Footer.termsOfUse" />
                        </NamedLink>
                      </li>
                      <li>
                        <NamedLink name="PrivacyPolicyPage" className={css.legalLink}>
                          <FormattedMessage id="Footer.privacyPolicy" />
                        </NamedLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div className={css.links}>
                {/* <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}>
                <Logo format="desktop" className={css.logo} />
              </NamedLink>
              <div className={css.organizationInfo}>
                <p className={css.organizationDescription}>
                  <FormattedMessage id="landing.headline1" />
                </p>
                <p className={css.organizationCopyright}>
                  <NamedLink name="LandingPage" className={css.copyrightLink}>
                    <FormattedMessage id="Footer.copyright" />
                  </NamedLink>
                </p>
              </div>
            </div> */}
                <div className={css.infoLinks}>
                  <ul className={css.list}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="Footer.intro" />
                      </h3>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink name="LandingPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.start" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink name="AboutPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.about" />
                      </NamedLink>
                    </li>

                  </ul>
                </div>

                <div className={css.searches}>
                  <ul className={css.list}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="TopbarDesktop.destinations" />
                      </h3>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=85.051129%2C179.00736739%2C-75.14077719%2C-160.60200761',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="worldwide" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=36.59497175%2C52.76846679%2C-36.15117826%2C-34.86957672',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="africa" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=64.09173416%2C169.49644716%2C-14.97311392%2C58.14770588',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="asia" />
                      </NamedLink>
                    </li>

                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search: '?bounds=70.58376206%2C43.23000513%2C35.74947721%2C-28.69256351',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="europe" />
                      </NamedLink>
                    </li>
                    <li className={css.listItem}>
                      <NamedLink
                        name="SearchPage"
                        to={{
                          search:
                            '?bounds=34.15056365%2C-25.99456573%2C-59.50348924%2C-150.22941462',
                        }}
                        className={css.link}
                      >
                        <FormattedMessage id="southamerica" />
                      </NamedLink>
                    </li>
                  </ul>
                </div>





                <div className={css.searchesExtra}>
                  <ul className={css.list}>
                    <h3 className={css.legalLink}>
                      <FormattedMessage id="Footer.info" />
                    </h3>
                    <li className={css.listItem}>
                      <NamedLink name="FaqPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.FAQ" />
                      </NamedLink>
                    </li>

                    <li className={css.listItem}>
                      <NamedLink name="ContactPage" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.Contact" />
                      </NamedLink>
                    </li>

                    <li className={css.listItem}>
                      <ExternalLink href="https://blog.socialbnb.org/press" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.Press" />
                      </ExternalLink>
                    </li>
                    <li className={css.listItem}>
                      <ExternalLink href="https://blog.socialbnb.org/" className={css.link}>
                        <FormattedMessage id="TopbarDesktop.Blog" />
                      </ExternalLink>
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={coronaEN}>
                          <FormattedMessage id="Footer.corona" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={coronaDE}>
                          <FormattedMessage id="Footer.corona" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={childProtectionPolicy}>
                          <FormattedMessage id="Footer.childProtectionPolicy" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={KinderschutzPolicy}>
                          <FormattedMessage id="Footer.childProtectionPolicy" />
                        </ExternalLink>
                      )}
                    </li>
                  </ul>
                </div>

                <div className={css.infoLinks}>
                  <ul className={css.list}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="Downloads" />
                      </h3>
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={safetyInfoEN}>
                          <FormattedMessage id="Footer.SafetyInfo" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={safetyInfoDE}>
                          <FormattedMessage id="Footer.SicherheitInfo" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={coronaEN}>
                          <FormattedMessage id="Footer.corona" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={coronaDE}>
                          <FormattedMessage id="Footer.corona" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={childProtectionPolicy}>
                          <FormattedMessage id="Footer.childProtectionPolicy" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={KinderschutzPolicy}>
                          <FormattedMessage id="Footer.childProtectionPolicy" />
                        </ExternalLink>
                      )}
                    </li>
                    <li>
                      {cookies.get('language') === 'en' ? (
                        <ExternalLink href={travelerGuidlines}>
                          <FormattedMessage id="Footer.guidline" />
                        </ExternalLink>
                      ) : (
                        <ExternalLink href={reisendeGuidlines}>
                          <FormattedMessage id="Footer.guidline" />
                        </ExternalLink>
                      )}
                    </li>
                  </ul>
                </div>






                <div className={css.extraLinks}>
                  <div className={css.legalMatters}>
                    <ul className={css.tosAndPrivacy}>
                      <li>
                        <h3 className={css.legalLink}>
                          <FormattedMessage id="Footer.legal" />
                        </h3>
                      </li>
                      <li>
                        <NamedLink name="Imprint" className={css.legalLink}>
                          <FormattedMessage id="Footer.imprint" />
                        </NamedLink>
                      </li>
                      <li>
                        <NamedLink name="TermsOfServicePage" className={css.legalLink}>
                          <FormattedMessage id="Footer.termsOfUse" />
                        </NamedLink>
                      </li>
                      <li>
                        <NamedLink name="PrivacyPolicyPage" className={css.legalLink}>
                          <FormattedMessage id="Footer.privacyPolicy" />
                        </NamedLink>
                      </li>
                    </ul>
                  </div>
                </div>

{/* funded by mobile footer
                <div>
                  <ul className={`${css.list} ${css.fundedByList}`}>
                    <li className={css.listItem}>
                      <h3 className={css.legalLink}>
                        <FormattedMessage id="Footer.fundedBy" />
                      </h3>
                    </li>

                    <div className={css.fundedByWrapper}>
                      <div className={css.fundedBy}>
                        <ExternalLink
                          href="https://www.bmwi.de/Navigation/DE/Home/home.html"
                          target="_blank"
                          style={{ height: '100%' }}
                        >
                          <img src={article1} alt="article1"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink>
                          <img src={article2} alt="article2"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink
                          href="https://www.esf.de/portal/DE/Startseite/inhalt.html"
                          target="_blank"
                          style={{ height: '100%' }}
                        >
                          <img src={article5} alt="article5"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink>
                          <img src={article6} alt="article6"></img>
                        </ExternalLink>
                      </div>

                      <div className={css.fundedBy}>
                        <ExternalLink
                          href="https://www.exist.de/DE/Home/inhalt.html"
                          target="_blank"
                          style={{ height: '100%' }}
                        >
                          <img src={article7} alt="article7"></img>
                        </ExternalLink>
                      </div>
                    </div>
                  </ul>
                </div> */}
              </div>
            )
          ) : null}
        </div>
        {/**/}
      </div>

      <div className={css.copyright}>
        <small>Copyright &copy; {currentYear} socialbnb</small>
      </div>
    </div>
  );
};

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
